'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.VERSION = void 0;
exports.VERSION = '4.0.0';
//# sourceMappingURL=version.js.map
